module.exports = __webpack_public_path__ + "images/project-branding-561f9503be3fb55535634c785bfb25d5.jpg";